import { render, staticRenderFns } from "./issue-dialog.vue?vue&type=template&id=de313ff4&scoped=true&"
import script from "./issue-dialog.vue?vue&type=script&lang=js&"
export * from "./issue-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de313ff4",
  null
  
)

export default component.exports